import { useEffect, useState, useRef } from 'react';
import { useParams, useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/stores/RootStore';
import { authApi } from '@/services/authApi';
import AuthShell from './AuthShell';
import s from './Auth.module.scss';

/**
 * [2026-09-10] 소셜 로그인 콜백 — /auth/callback/:provider?code=&state=.
 *   provider가 redirect한 code를 백엔드로 보내 교환→JWT 수령→로그인. 성공 시 홈으로.
 */
export default function SocialCallback() {
	const { provider = '' } = useParams();
	const [sp] = useSearchParams();
	const auth = useAuth();
	const nav = useNavigate();
	const [err, setErr] = useState<string | null>(null);
	const ran = useRef(false);

	useEffect(() => {
		if (ran.current) return; ran.current = true;   // StrictMode 중복 실행 방지(code 1회용)
		const code = sp.get('code');
		const state = sp.get('state') || undefined;
		const errParam = sp.get('error');
		if (errParam || !code) { setErr('소셜 로그인이 취소되었거나 실패했습니다.'); return; }
		const redirectUri = `${window.location.origin}/auth/callback/${provider}`;
		(async () => {
			const r = await authApi.socialLogin(provider, code, redirectUri, state);
			const msg = auth.applySocialResult(r);
			if (msg) { setErr(msg); return; }
			// [2026-09-11 #4] 소셜 신규가입은 PENDING → 완료단계(전화번호·약관·유효기간) 페이지로. 기존/연동 회원은 홈으로.
			if (r.needsCompletion) nav('/auth/complete', { replace: true });
			else nav('/', { replace: true });
		})();
	}, [provider, sp, auth, nav]);

	return (
		<AuthShell eyebrow="EVS MEMBERSHIP" title={<>{provider === 'naver' ? '네이버' : 'Google'} 로그인</>}
			desc={err ? undefined : '로그인 처리 중입니다…'}>
			{err ? (
				<>
					<div className={`${s.msg} ${s.error}`}>{err}</div>
					<div className={s.links}><Link to="/login">로그인으로 돌아가기</Link></div>
				</>
			) : (
				<p className={s.hint}>잠시만 기다려 주세요.</p>
			)}
		</AuthShell>
	);
}
